
<template>
  <v-dialog v-model="dialog" width="500px" transition="dialog-bottom-transition" scrollable >
    <template v-slot:activator="{ on }">
      <f-btn edit v-on="on" small class="ml-2"></f-btn>
    </template>
    <v-card v-if="dialog">
      <v-card-title>
        <span class="headline">Editando comentário do cliente</span>
      </v-card-title>
      <v-card-text>
        <v-textarea label="Comentário" v-model="local_comment"></v-textarea>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <f-btn @click="closeDialog" cancel></f-btn>
        <f-btn @click="submitComment" :disabled="!local_comment" save></f-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex'
import Api from '@/api/index';

export default {
  name: 'ClientEditCommentDialog',
  data() {
    return {
      dialog: false,
      local_comment: null
    }
  },
  mounted () {
    this.setLocalComment();
  },
  methods: {
    closeDialog() {
      this.setLocalComment();
      this.dialog = false;
    },
    submitComment() {
      Api.Client.basicUpdate({ id: this.oneClient.data.id, comment: this.local_comment })
      .then(() => {
        this.addNotification({type: 'success',  msg: `Cliente atualizado com sucesso`})
      })
      .catch(er => {
        this.addNotification({type: 'error',  msg: `${er}`})
      })
      .finally(()=>{
        this.dialog = false;
      })
    },
    setLocalComment() {
      this.local_comment = this.oneClient.data.attributes.comment
    },
    ...mapActions({
      
    })
  },
  computed: {
    ...mapState({
      oneClient: state => state.Client.oneClient,
    })
  },
  watch: {
    data(nv,ov) {
      if (nv){
      } else if (nv == false){
      }
    }
  },
}
</script>

<style scoped>

</style>